import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-shell" }

import { defineAsyncComponent } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const PrepareUniver = defineAsyncComponent(() => import('@/components/PrepareUniver.vue'))

const currentUser = {
  id: 'local-user',
  name: '本地用户',
  tenantId: 'local',
  workbookKey: 'standalone-univer',
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(_unref(PrepareUniver), {
          "user-id": currentUser.id,
          "user-name": currentUser.name,
          "tenant-id": currentUser.tenantId,
          "workbook-key": currentUser.workbookKey
        }, null, 8, ["user-id", "user-name", "tenant-id", "workbook-key"])
      ]),
      fallback: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "editor-loading" }, "正在加载表格编辑器...", -1)
      ]))]),
      _: 1
    }))
  ]))
}
}

})